import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import debounce from "lodash/debounce";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./UserSelectInput.style";

export const UserSelectInput = ({
    value,
    onChange,
    role = "all",
    disabled = false,
    initialCall = false,
    mode = undefined,
    allowClear = false,
    limit = 10,
    activity = true,
    showSearch = true,
    showTitle = true,
    marginBottom = "0px"
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();
    const [searchText, setSearchText] = useState("");

    const [loading, users] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.userStore.getUserList.bind(null, {
            limit,
            page: 1,
            city: "all",
            role: role,
            role,
            activity,
            searchText: searchText && searchText.toLocaleLowerCase("tr-TR")
        }),
        dependencies: [searchText],
        initialCall: initialCall
    });

    const debounceTimeout = 400;
    const onSearch = useMemo(
        value => {
            const loadOptions = value => {
                setSearchText(value);
            };
            return debounce(loadOptions, debounceTimeout);
        },
        [debounceTimeout]
    );
    return (
        <React.Fragment>
            {showTitle ? <h5>{t("fields.users", {ns: "common"})}</h5> : <></>}
            <SelectField
                loading={loading}
                data-testid="userSelect"
                value={value}
                onChange={onChange}
                disabled={disabled && poolsLoading}
                mode={mode}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear={allowClear}
                showSearch={showSearch}
                onSearch={onSearch}
                mb={marginBottom}
            >
                {users?.rows &&
                    users?.rows.length > 0 &&
                    arrayAlphabeticalSort([...users?.rows], "fullName").map(user => (
                        <SelectField.Option
                            key={user._id}
                            value={user._id}
                            data-testid="useSelect_option"
                        >
                            {user?.fullName}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    );
};
